import apiClient from './index';
import { AddressSuggestRequest, AddressSuggestResponse } from './types';

export const addressApi = {
  async suggest(payload: AddressSuggestRequest): Promise<AddressSuggestResponse> {
    const response = await apiClient.post<AddressSuggestResponse>('/address/suggest', payload);
    return response.data;
  },
};
